import { InputNumber, Select } from '@ui/src';
import { ManualRiskScoreFormTypes } from './types';

import cn from './styles.module.css';

let manualRiskScoreTimeout: NodeJS.Timeout;

const ManualRiskScoreForm = ({
  totalRiskScoreLevel,
  riskScoreRanges,
  setTotalRiskScoreLevel,
  setTotalRiskScore,
  totalRiskScore,
}: ManualRiskScoreFormTypes) => (
  <>
    <div className={cn.manualRiskScoreDescription}>
      Select a Risk level or enter an exact risk score value.
    </div>
    <div className={cn.manualRiskScoreFormGroup}>
      <Select
        name="riskLevel"
        title="Risk Level"
        value={totalRiskScoreLevel}
        list={riskScoreRanges?.map((item) => ({
          name: `${item.name.charAt(0)}${item.name
            .slice(1)
            .toLowerCase()} (${item.rangeStart} - ${item.rangeEnd})`,
          value: item.id,
          suffix: `${item.rangeStart} - ${item.rangeEnd}`,
        }))}
        onChange={(e) => {
          setTotalRiskScoreLevel(e.target.value as string);
          setTotalRiskScore(
            riskScoreRanges?.find(
              (item) => item.id === (e.target.value as string),
            )?.rangeStart as number,
          );
        }}
        fullWidth
      />
    </div>
    <div className={cn.manualRiskScoreFormGroup}>
      <InputNumber
        name="riskScore"
        title="Risk Score"
        value={totalRiskScore}
        placeholder="Enter risk score"
        maxLength={100}
        onChange={(e) => {
          clearTimeout(manualRiskScoreTimeout);
          const value =
            Number(e.target.value) > 100 ? 100 : Number(e.target.value);

          setTotalRiskScore(value);

          manualRiskScoreTimeout = setTimeout(() => {
            setTotalRiskScoreLevel(
              riskScoreRanges?.find(
                (item) => value >= item.rangeStart && value <= item.rangeEnd,
              )?.id as string,
            );
          }, 300);
        }}
      />
    </div>
  </>
);

export default ManualRiskScoreForm;
